import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCb2BY-VJPF-GoodNZ02gOwoauaSjoNJ2g",
  authDomain: "dasara-lodge.firebaseapp.com",
  projectId: "dasara-lodge",
  storageBucket: "dasara-lodge.firebasestorage.app",
  messagingSenderId: "586191153374",
  appId: "1:586191153374:web:ce5607d95ad6e9fce57a4f",
  measurementId: "G-9NERM96PFW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;